import Decimal from 'decimal.js-light';
import i18n from "@/plugins/i18n"

/**
 * Рассчет ЦП с учетом выбранного НДС.
 *
 * @param {number|string|Decimal} price ЦП без НДС
 * @param {number|string|Decimal} ndsRate ставка НДС
 * @returns {String} ЦП с НДС
 */
export function calcPriceNdsByPrice(price, ndsRate) {
  const priceDec = price != null ? new Decimal(price) : new Decimal(0);
  const ndsRateDec = ndsRate != null ? new Decimal(ndsRate) : new Decimal(0);

  return priceDec.times(ndsRateDec.dividedBy(100).plus(1)).toDecimalPlaces(2).toString();
}

/**
 * Рассчет ЦП без НДС по цене с НДС.
 *
 * @param {number|string|Decimal} priceNds ЦП с НДС
 * @param {number|string|Decimal} ndsRate ставка НДС
 * @returns {String} ЦП без НДС
 */
export function calcPriceByPriceNds(priceNds, ndsRate) {
  const priceNdsDec = priceNds != null ? new Decimal(priceNds) : new Decimal(0);
  const ndsRateDec = ndsRate != null ? new Decimal(ndsRate) : new Decimal(0);

  return priceNdsDec.dividedBy(ndsRateDec.dividedBy(100).plus(1)).toDecimalPlaces(2).toString();
}

/**
 * Рассчет суммы НДС.
 *
 * @param {number|string|Decimal} priceNds ЦП с НДС
 * @param {number|string|Decimal} price ЦП без НДС
 * @returns {Decimal} Сумма НДС
 */
export function calcNds(priceNds, price) {
  // Проверка на null/undefined и преобразование в 0
  const priceNdsDec = priceNds != null ? new Decimal(priceNds) : new Decimal(0);
  const priceDec = price != null ? new Decimal(price) : new Decimal(0);

  return priceNdsDec.minus(priceDec);
}

/**
 * Текст С НДС/БЕЗ НДС
 *
 * @param ndsRate ставка НДС
 * @param showPercentage показывать ставку/нет
 */
export function getIsNdsText(ndsRate, showPercentage = false) {
  if (!!ndsRate || ndsRate === 0) {
    return i18n.global.t('(c НДС{_1})', {'_1': showPercentage ? ' '+ndsRate+'%' : ''})
  } else {
    return i18n.global.t('(без НДС)')
  }
}
